/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RestService } from '../../common';
var ExtendzApiTableHostComponent = /** @class */ (function () {
    function ExtendzApiTableHostComponent(activatedRoute, router, rest) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.rest = rest;
    }
    ExtendzApiTableHostComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.all$ = this.activatedRoute.params.subscribe(function (param) {
            _this.model = param.name;
            _this.id = param.id;
        });
    }; // ngOnInit()
    ExtendzApiTableHostComponent.prototype.ngOnDestroy = function () {
        if (this.all$)
            this.all$.unsubscribe();
    };
    ExtendzApiTableHostComponent.prototype.onSelect = function (item) {
        var id = '0';
        if (item && item._links.self.href) {
            id = this.rest.getId(item._links.self.href);
        }
        this.router.navigate([id], { relativeTo: this.activatedRoute });
    }; //onSelect
    ExtendzApiTableHostComponent = tslib_1.__decorate([
        Component({
            selector: 'ext-api-table-host',
            template: "<ext-api-table [model]=\"model\" (select)=\"onSelect($event)\"></ext-api-table> <div style=\"height: 17vh;width: 100%\"></div> <div> <button mat-fab class=\"bottom-right\" (click)=\"onSelect($event)\"> <mat-icon> <svg id=\"add\" viewBox=\"0 0 24 24\"> <path d=\"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> </button> </div>",
            styles: ["/** *   Copyright 2018 the original author or authors * *   Licensed under the Apache License, Version 2.0 (the \"License\"); *   you may not use this file except in compliance with the License. *   You may obtain a copy of the License at * *       http://www.apache.org/licenses/LICENSE-2.0 * *   Unless required by applicable law or agreed to in writing, software *   distributed under the License is distributed on an \"AS IS\" BASIS, *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. *   See the License for the specific language governing permissions and *   limitations under the License. */ .bottom-right { position: fixed; bottom: 78px; right: 24px; } /*# sourceMappingURL=api-table-host.component.css.map */ "]
        }),
        tslib_1.__metadata("design:paramtypes", [ActivatedRoute,
            Router,
            RestService])
    ], ExtendzApiTableHostComponent);
    return ExtendzApiTableHostComponent;
}()); // class
export { ExtendzApiTableHostComponent };
//# sourceMappingURL=extendz-api-table-host.component.js.map